import React, { FC } from "react";
import { ComponentAddressAddress } from "../../queries/auto-generated/schemas";

const Address: FC<{ address: ComponentAddressAddress }> = ({ address }) => {
  const {
    address_line_1,
    address_line_2,
    locality: city,
    administrative_district_level_1: state,
    postal_code,
  } = address;

  return (
    <>
      <div>
        {address_line_1}
        {address_line_2 ? ", " : ""}
        {address_line_2}
      </div>
      <div>{`${city}, ${state} ${postal_code}`}</div>
    </>
  );
};

export default Address;
